export default __webpack_public_path__ + "static/media/cerec_first.ec3c35f2.jpg";